import React from "react";
import { Controller, useFormState } from "react-hook-form";
import FormErrorMessage from "./FormErrorMessage";

export const FormHelperText = ({ children }) => {
  return (
    <div className="bg-dark-grey-lighter color-dark-grey-darker p-1">
      {children}
    </div>
  );
};

// const getStyles = (rowPosition) => {
//   let rowStyles = null;
//   switch (rowPosition) {
//     case false:
//       rowStyles = {backgroundColor: 'transparent'};
//       break;
//     case true:
//       rowStyles = {backgroundColor: 'hsl(0deg 0% 100% / 50%)'};
//       break;
//     case "first":
//       rowStyles = {backgroundColor: 'hsl(0deg 0% 100% / 50%)', borderRadius: '4px 0 0 4px'};
//       break;
//     case "last":
//       rowStyles = {backgroundColor: 'hsl(0deg 0% 100% / 50%)', borderRadius: '0 4px 4px 0'};
//       break;
//     default:
//       break;
//   }
//   return rowStyles;
// };

const FormRadioGroup = ({
  name,
  label,
  labelHelp,
  helperText,
  labelClassName = "",
  wrapperClassName="",
  trigger,
  control,
  onChangeCallBack,
  options,
  required = false,
  readOnly = false,
  disabled = false,
  rowPosition = false // false, true, first, last
}) => {
  const { errors } = useFormState({ control });

  return (
    <fieldset className={`form-field ${wrapperClassName}`} aria-labelledby={`${name}-label`}>
      <legend id={`${name}-label`} className={`form-label align-left ${labelClassName}`} style={{width: '100%'}}>
        {required && (
          <span className="form-layout-required" aria-label="required">
            *
          </span>
        )}
        {label}
        {labelHelp && <span className="font-italic ml-1">{labelHelp}</span>}
      </legend>
      <div className="form-layout-input">
        <ul className="form-group-options">
          {options.map((option) => (
            <li key={option.value} className="m-0 align-items-baseline">
              <Controller
                name={name}
                control={control}
                render={({ field }) => {
                  return <>
                    <input
                      id={`${name}_${option.value}`}
                      data-testid={`steptable_${name}_${option.value}_radio`}
                      type="radio"
                      name={name}
                      value={option.value}
                      readOnly={readOnly}
                      disabled={disabled}
                      checked={field.value === option.value}
                      onChange={(e) => {
                        const val =
                          typeof option.value === "boolean"
                            ? e.target.value === "true"
                            : e.target.value;
                        field.onChange(val);
                        if (onChangeCallBack) {
                          onChangeCallBack(val);
                        }
                        if (trigger) {
                          trigger(name);
                        }
                      }}
                    />
                    <label
                      htmlFor={`${name}_${option.value}`}
                      className="color-black"
                    >
                      {option.label}
                    </label>
                  </>
                }}
              />
            </li>
          ))}
        </ul>
      </div>
      {errors[name] && (
        <FormErrorMessage message={errors[name].message} />
      )}
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </fieldset>
  );
};

export default FormRadioGroup;